import React, { Component } from "react";
import { connect } from "react-redux";
import { Icon, Checkbox, Dropdown } from "semantic-ui-react";
import { fetchFbPageLikesData } from "../../../actions/fbInsightsAction";
import ReactHighcharts from "react-highcharts";
import { formatfbInsightsData } from "../../../actions/utils";
var moment = require("moment");

class TotalLikesBySource extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chartType: "line",
            showGridLines: true,
            showUnique: false,
        };
    }

    renderDownloadButton() {
        return (
            <Dropdown trigger={<Icon name={"download"} />} icon={null} className="chart-download-dropdown hideable" pointing="top right	">
                <Dropdown.Menu>
                    <Dropdown.Item> CSV </Dropdown.Item>
                    <Dropdown.Item> PNG </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    }

    shouldComponentUpdate(prevProps, prevState) {
        if (prevProps.showInfo != this.props.showInfo) {
            return false;
        } else {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showUnique != this.state.showUnique) {
            let data = {
                duration: this.props.duration,
                startDateTime: moment(this.props.startDateTime).format("YYYY-MM-DD"),
                endDateTime: moment(this.props.endDateTime).format("YYYY-MM-DD"),
            };
            this.props.fetchFbPageLikesBySourceUniqueData(data, this.state.showUnique);
        }
    }

    change_graph_type(type) {
        this.setState({
            chartType: type,
        });
    }

    toggleGridLines(d) {
        this.setState({
            showGridLines: d.checked,
        });
    }

    toggleUnique(d) {
        this.setState({
            showUnique: d.checked,
        });
    }

    render() {
        let x = this.props.totalPageLikesBySource
            ? formatfbInsightsData(this.props.totalPageLikesBySource, this.props.startDateTime, this.props.endDateTime, "totalLikesBySource")
            : {};
        const pageLikesConfig = {
            plotOptions: {
                line: {
                    marker: {
                        enabled: false,
                    },
                },
                series: {
                    cursor: "pointer",
                    // events: {
                    //     click: (event) => {
                    //         this.showChartsResultsPage(event, 2)
                    //     }
                    // }
                },
            },
            chart: {
                className: "skiptranslate",
                height: 300,
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No Data.",
            },
            legend: {
                itemStyle: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                    color: "#1f2e3d",
                },
                alignColumns: false,
                align: "right",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#1f2e3d",
                    fontFamily: "'Roboto', sans-serif",
                },
                position: {
                    align: "center",
                },
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                gridLineWidth: this.state.showGridLines ? 1 : 0,
                minorGridLineWidth: 0,
                allowDecimals: false,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%H:%M:%S.%L",
                    second: "%H:%M:%S",
                    minute: "%H:%M",
                    hour: "%H:%M",
                    day: "%e %b %Y",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                tickInterval: 24 * 3600 * 1000,
                labels: {
                    style: {
                        fontFamily: "'Roboto', sans-serif",
                        color: "#1f2e3d",
                    },
                },
            },
            tooltip: {
                shared: true,
                crosshairs: true,
                backgroundColor: "#fff",
                borderRadius: 6,
            },
            series: [
                { color: "#53BEA7", name: "Ads", data: x.adsLikeType ? x.adsLikeType.data : [] },
                { color: "#A070CF", name: "Mobile", data: x.mobileLikeType ? x.mobileLikeType.data : [] },
                { color: "#FBD352", name: "News Feed", data: x.newsFeedLikeType ? x.newsFeedLikeType.data : [] },
                { color: "#AF388E", name: "Page Suggestions", data: x.pageSuggestionsLikeType ? x.pageSuggestionsLikeType.data : [] },
                {
                    color: "#F17F4F",
                    name: "Restored likes from reactivated accounts",
                    data: x.restoredLikesFromReactivatedAccounts ? x.restoredLikesFromReactivatedAccounts.data : [],
                },
                { color: "#F0EEC4", name: "Search", data: x.searchLikeType ? x.searchLikeType.data : [] },
                { color: "#B194C2", name: "Your Page", data: x.yourPageLikeType ? x.yourPageLikeType.data : [] },
            ],
            time: {
                useUTC: true,
            },
        };
        const pageLikesColumnConfig = {
            //renderTo: 'charts-column',
            plotOptions: {
                series: {
                    cursor: "pointer",
                    stacking: "normal",
                },
            },
            chart: {
                height: 300,
                type: "column",
            },
            credits: {
                enabled: false,
            },
            title: {
                text: "",
            },
            yAxis: {
                title: "",
                allowDecimals: false,
            },
            xAxis: {
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%H:%M:%S.%L",
                    second: "%H:%M:%S",
                    minute: "%H:%M",
                    hour: "%H:%M",
                    day: "%e %b %Y",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                tickInterval: 24 * 3600 * 1000,
                labels: {
                    style: {
                        fontFamily: "'Roboto', sans-serif",
                        color: "#1f2e3d",
                    },
                },
            },
            lang: {
                noData: "No Data.",
            },
            legend: {
                itemStyle: {
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "capitalize ",
                    color: "#1f2e3d",
                },
                alignColumns: false,
                align: "right",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "14px",
                    color: "#1f2e3d",
                    fontFamily: "'Roboto', sans-serif",
                },
                position: {
                    align: "center",
                },
            },
            tooltip: {
                backgroundColor: "#fff",
                borderRadius: 6,
            },
            series: [
                { color: "#53BEA7", name: "Ads", data: x.adsLikeType ? x.adsLikeType.data : [] },
                { color: "#A070CF", name: "Mobile", data: x.mobileLikeType ? x.mobileLikeType.data : [] },
                { color: "#FBD352", name: "News Feed", data: x.newsFeedLikeType ? x.newsFeedLikeType.data : [] },
                { color: "#AF388E", name: "Page Suggestions", data: x.pageSuggestionsLikeType ? x.pageSuggestionsLikeType.data : [] },
                {
                    color: "#F17F4F",
                    name: "Restored likes from reactivated accounts",
                    data: x.restoredLikesFromReactivatedAccounts ? x.restoredLikesFromReactivatedAccounts.data : [],
                },
                { color: "#F0EEC4", name: "Search", data: x.searchLikeType ? x.searchLikeType.data : [] },
                { color: "#B194C2", name: "Your Page", data: x.yourPageLikeType ? x.yourPageLikeType.data : [] },
            ],
            time: {
                useUTC: true,
            },
        };

        return (
            <div style={{ background: "#fff" }}>
                <div className="top_buttons" style={{ display: "flex", paddingBottom: "10px", justifyContent: "flex-end" }}>
                    {/* {this.renderDownloadButton()} */}
                    <Checkbox
                        label="Show Grid Lines"
                        checked={this.state.showGridLines}
                        onChange={(e, d) => this.toggleGridLines(d)}
                        className="hideable gridlines"
                    />
                    <Checkbox label="Show Unique" checked={this.state.showUnique} onChange={(e, d) => this.toggleUnique(d)} className="hideable unique" />
                </div>
                <ReactHighcharts
                    style={{ paddingTop: "4%" }}
                    config={this.state.chartType == "line" ? pageLikesConfig : pageLikesColumnConfig}></ReactHighcharts>
                <div className="row chartToolbar toggle__chartType">
                    <div className="changeType">
                        <span>
                            <Icon className={this.state.chartType == "pie" ? "active" : ""} onClick={() => this.change_graph_type("pie")} name={"pie chart"} />{" "}
                        </span>
                        <span>
                            <Icon className={this.state.chartType == "bar" ? "active" : ""} onClick={() => this.change_graph_type("bar")} name={"bar chart"} />{" "}
                        </span>
                        <span>
                            <Icon
                                className={this.state.chartType == "line" ? "active" : ""}
                                onClick={() => this.change_graph_type("line")}
                                name={"line chart"}
                            />{" "}
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        totalPageLikesBySource: state.fbInsightsReducer.totalPageLikesBySource,
        activeIndex: state.fbInsightsReducer.PageLikesChartsTabIndex,
        duration: state.fbInsightsReducer.duration,
        startDateTime: state.fbInsightsReducer.startDateTime,
        endDateTime: state.fbInsightsReducer.endDateTime,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        fetchFbPageLikesBySourceUniqueData: (data, selectedFbPage, is_unique) => {
            let chartName = "totalLikesBySource";
            fetchFbPageLikesData(dispatch, data, chartName, is_unique);
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(TotalLikesBySource);
